const hasSpecs = (state) =>
  state.specs ? Boolean(Object.keys(state.specs).length) : false

const specFormHasErrors = (state) =>
  Object.values(state.specsFormValidation).some((el) => el.isInvalid === true)

const offers = (state) => state[state.activeOfferContext] || {}
const contract = (state) => state.contract

const offer = (state, getters) => {
  return getters.isSimulatedOfferContext
    ? state.simulatedOffer
    : getters.offers?.[state.selectedOffer] || {}
}

const hasOffers = (_, getters) => Boolean(Object.keys(getters.offers).length)
const hasContract = (_, getters) => Boolean(getters.contract !== null)

const isSingleOffer = (_, getters) => {
  const { hasOffers, offers } = getters

  return hasOffers ? offers.recommended.panels === offers.standard.panels : null
}

const isFinanced = (state) => {
  return state.selectedFinancingCondition !== 'cash'
}

const financingCondition = (state) => {
  return (
    state.financingConditions.find(
      (fc) => fc.id === state.selectedFinancingCondition
    ) || {}
  )
}

const monthlyLoanWithTaxesIsUnderMinQuota = (state, getters) => {
  return state.selectedFinancingCondition === 'cash'
    ? false
    : Number(getters.offer.financingData.monthlyLoanWithTaxes) <
        Number(getters.offer.financingData.minQuota)
}

const isOfferReduced = (state, getters) => {
  return getters.isSimulatedOfferContext
    ? state.simulatedOffer.offerResizeInfo?.startsWith('reduced')
    : getters.offer?.offerResizeInfo?.startsWith('reduced')
}
const isSimulatedOfferContext = (state) => {
  return state.activeOfferContext === 'simulatedOffer'
}

// Total y "hay descuentos" se basan en lo APLICADO por el BE (simulatedOffer.discounts),
// no en lo que el agente está tecleando (state.specs.discounts). Así el precio total y
// el tachado se mantienen estables hasta que se pulse "Aplicar descuentos".
const totalValueWithDiscounts = (_state, getters) => {
  if (!getters.hasDiscounts) {
    return getters.offer.totalValueWithoutDiscounts
  }
  return Object.values(getters.appliedDiscounts).reduce(
    (acc, discount) => acc - Number(discount),
    getters.offer.totalValueWithoutDiscounts
  )
}

const hasDiscounts = (_state, getters) => {
  const applied = getters.appliedDiscounts
  return (
    applied &&
    Object.keys(applied).length > 0 &&
    Object.values(applied).some((discount) => Number(discount) > 0)
  )
}

const appliedDiscounts = (state) => state.simulatedOffer?.discounts ?? {}

// El getter expone lo "aplicado" (último simulate exitoso), no lo pendiente.
// Mismo principio que el módulo installationSimulator: el descuento solo
// afecta a la UI (precio del item, total, M.I.) tras pulsar "Aplicar
// descuentos". El valor pendiente vive en state.specs.discounts y se manda
// al BE en el momento del Apply.
const discounts = (state, getters) => {
  return getters.isSimulatedOfferContext
    ? getters.appliedDiscounts
    : getters.offer.discounts
}

const hasPendingDiscount = (state) => {
  const specs = state.specs?.discounts ?? {}
  const applied = state.simulatedOffer?.discounts ?? {}
  const keys = ['panels', 'battery', 'evCharger', 'certificate']
  return keys.some((k) => Number(specs[k] ?? 0) !== Number(applied[k] ?? 0))
}

const canOffer = (state) => state.simulatedOffer?.canOffer !== false

const listAssets = (state) => {
  return Object.values(state.assetsCatalog)
    .sort((a, b) => a.capacity - b.capacity)
    .reduce((acc, item) => {
      acc[item.id] = {
        ...item,
        id: item.id,
        amount: Object.values(state.specs.assets).find(
          (asset) => asset.id === item.id
        )
          ? Object.values(state.specs.assets).find(
              (asset) => asset.id === item.id
            ).amount
          : 0,
      }
      return acc
    }, {})
}

export default {
  hasSpecs,
  specFormHasErrors,
  offers,
  offer,
  hasOffers,
  isSingleOffer,
  isFinanced,
  financingCondition,
  monthlyLoanWithTaxesIsUnderMinQuota,
  isOfferReduced,
  isSimulatedOfferContext,
  contract,
  hasContract,
  totalValueWithDiscounts,
  hasDiscounts,
  appliedDiscounts,
  discounts,
  hasPendingDiscount,
  canOffer,
  listAssets,
}
